<script>
    /*
    	RemoveResourcePopup.svelte
    */

    import { onMount } from 'svelte';
    import { fade, scale } from 'svelte/transition';

    // TCARE components

    // SMUI components

    const SVG_ICON_PATH = 'img/remove_resource.svg';

    export let onCancel;
    export let onConfirm;
    export let resource;
    

    onMount(() => {
    })

    const _onClickOutside = (e) => {
        onCancel();
    }

    const _onClickInside = (e) => {
        e.stopPropagation();
    }

    const _onCancel = (e) => {
        e.stopPropagation();
        onCancel();
    }

    const _onConfirm = (e) => {
        e.stopPropagation();
        onConfirm(resource);
    }

</script>

<style>
    .remove-popup-bg {
        z-index: 999;     /* should be above EVERYTHING even header, footer */
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        color: var(--tcui-primary);
        background-color: rgba(123, 98, 126, .3);
    }

    .remove-popup-surface {
        position: relative;
        width: 510px;
        margin: auto;
        margin-top: 30vh;
        background-color: white;
        border-radius: 40px;
    }
    
    .remove-popup-surface .popup-button {
        width: 110px;
    }

    .remove-popup-surface .popup-button .button-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .remove-popup-surface .popup-button svg {
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }

    .remove-popup-surface .popup-button:hover svg path {
        stroke: white;
    }




    .flex-row {
        width: 100%;
        text-align: center;
    }

    .flex-row.middle {
        width: 80%;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .flex-row.bottom {
        margin-top: 40px;
        padding-bottom: 30px;
    }

    .banner {
        width: 94%;
        height: 140px;
        margin: auto;
        margin-top: 20px;
        font-size: 26px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: var(--tcui-secondary);
        background-color: #F8F3F8;
        border-radius: 18px;
        letter-spacing: 1.1px;
    }

    .banner img {
        margin-bottom: 5px;
    }

    .text-1 {
        margin-top: 35px;
        margin-bottom: 10px;
    }
    
    .spacer {
        width: 10px;
    }
    
    

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

    <div class="remove-popup-bg" transition:fade on:click={(e) => _onClickOutside(e)} >
        <div class="remove-popup-surface" on:click={(e) => _onClickInside(e)} in:scale="{{ from: .8, duration: 250 }}" out:fade >

            <div class="flex-row jc-center top">
                <div class="banner">
                    <img src={SVG_ICON_PATH} alt={'Resource Saved'} draggable="false" >
                    Remove Resource?
                </div>
            </div>

            <div class="flex-row jc-center middle">
                <div class="text-1">
                    This resource will be removed from your list.
                </div>
                You can access it again from the Resource Explorer.
            </div>

            <div class="flex-row jc-center bottom">
                <button class="tcui-button periwinkle popup-button" on:click={(e) => _onCancel(e)}>
                    Cancel
                </button>
                <div class="spacer"></div>
                <button class="tcui-button periwinkle popup-button" on:click={(e) => _onConfirm(e)}>
                    <div class="button-content">
                        <div>Remove</div>
                        <!-- <img src='/img/garbage_can.svg' alt='colored shape' draggable="false"> -->
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.75 3.5H2.91667H12.25" stroke="#611C73" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.6665 3.49999V2.33332C4.6665 2.0239 4.78942 1.72716 5.00821 1.50837C5.22701 1.28957 5.52375 1.16666 5.83317 1.16666H8.1665C8.47592 1.16666 8.77267 1.28957 8.99146 1.50837C9.21025 1.72716 9.33317 2.0239 9.33317 2.33332V3.49999M11.0832 3.49999V11.6667C11.0832 11.9761 10.9603 12.2728 10.7415 12.4916C10.5227 12.7104 10.2259 12.8333 9.9165 12.8333H4.08317C3.77375 12.8333 3.47701 12.7104 3.25821 12.4916C3.03942 12.2728 2.9165 11.9761 2.9165 11.6667V3.49999H11.0832Z" stroke="#611C73" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5.8335 6.41667V9.91667" stroke="#611C73" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8.1665 6.41667V9.91667" stroke="#611C73" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>                            
                    </div>
                </button>
            </div>
        </div>
    </div>
